import { type PropsWithChildren } from "react";
import { NavLink } from "react-router-dom";
import useUser from "@hooks/user.hook";

interface AdminNavLinkProps {
  to: string;
  text?: string;
}

export function AdminNavLink({
  to,
  text,
  children
}: Readonly<PropsWithChildren<AdminNavLinkProps>>) {
  const { isAdmin } = useUser();

  if (!isAdmin) {
    return <></>;
  }

  return (
    <NavLink to={to} className="nav-link sg-flex align-items-center">
      {children}
      {text}
    </NavLink>
  );
}
